import { ReactElement, ReactNode, createContext, useContext } from "react";

// Used to pass any slideshow specific properties to nested components

interface SlideShowContextType {
  onSlideFinished: () => void;
  onSlideExited: () => void;
}

export const SlideShowContext = createContext<SlideShowContextType>({
  onSlideFinished: () => {
    // void
  },
  onSlideExited: () => {
    // void
  },
});

interface Props {
  onSlideFinished: () => void;
  onSlideExited: () => void;
  children: ReactNode;
}

export default function SlideShowProvider({
  children,
  onSlideFinished,
  onSlideExited,
}: Props): ReactElement {
  return (
    <SlideShowContext.Provider
      value={{
        onSlideFinished,
        onSlideExited,
      }}
    >
      {children}
    </SlideShowContext.Provider>
  );
}

export const useSlideShowContext = (): SlideShowContextType =>
  useContext(SlideShowContext);
